/* eslint-disable import/prefer-default-export */
export enum BillingType {
  SINGLE = 'SINGLE',
  RETROACTIVE = 'RETROACTIVE'
}
